import { MDXProps } from 'mdx/types'
import React from 'react'

import residential_field_study_workflow from './residential_field_study_workflow.mdx'

// import Playground from './playground.mdx'

import {
    type BaseData,
    type BaseMetadata,
    type Project,
} from '../types/database.types'

export interface TemplateProps {
    project?: PouchDB.Core.Document<Project> & PouchDB.Core.GetMeta
    data: BaseData
    metadata: BaseMetadata
}

export interface TemplateConfiguration {
    title: string
    subtitle?: string
    template: React.FC<MDXProps & TemplateProps>
}

const TEMPLATES: Record<string, TemplateConfiguration> = {
    residential_field_study_workflow: {
        title: 'IECC Data Collection Form',
        subtitle: 'Data Collection',
        template: residential_field_study_workflow,
    },
    // playground: {
    //     title: 'Playground',
    //     template: Playground,
    // },
}

const RESERVED_TEMPLATE_KEYS: string[] = ['workflows']

const RE_TEMPLATE_KEY = /^(?!_)(?!.*_$)[a-z0-9_]{1,64}$/i

Object.keys(TEMPLATES).forEach(key => {
    if (RESERVED_TEMPLATE_KEYS.includes(key) || !RE_TEMPLATE_KEY.test(key)) {
        throw new Error(`Invalid template key: ${JSON.stringify(key)}`)
    }
})

export default TEMPLATES
